import { useState, type FormEvent } from 'react'
import { Link, Navigate, useNavigate, useSearchParams } from 'react-router-dom'
import { useAuth } from '../AuthProvider'
import { api } from '../api'
import { Button } from '../../components/ui/Button'

export function ClientResetPasswordPage() {
  const { isAuthenticated } = useAuth()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const [token, setToken] = useState(() => (searchParams.get('token') || '').trim())
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [error, setError] = useState('')
  const [info, setInfo] = useState('')
  const [busy, setBusy] = useState(false)

  if (isAuthenticated) {
    return <Navigate to="/app" replace />
  }

  async function onSubmit(e: FormEvent) {
    e.preventDefault()
    setBusy(true)
    setError('')
    setInfo('')
    try {
      if (password !== confirm) {
        setError('New password confirmation does not match')
        return
      }
      await api.resetPassword({
        token: token.trim(),
        newPassword: password,
        confirmPassword: confirm,
      })
      setInfo('Password updated. You can sign in.')
      navigate('/app/login', {
        replace: true,
        state: { notice: 'Password updated. You can sign in.' },
      })
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Reset failed')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="cp-auth">
      <form className="cp-auth__card" onSubmit={(e) => void onSubmit(e)}>
        <p className="cp-eyebrow">Client Panel</p>
        <h1>Reset password</h1>
        <p className="cp-muted">Choose a new password for your Perfect Predict account.</p>
        {error ? <p className="cp-error">{error}</p> : null}
        {info ? <p className="cp-ok">{info}</p> : null}
        <label className="cp-field">
          Reset token
          <input
            value={token}
            onChange={(e) => setToken(e.target.value)}
            required
            minLength={8}
            autoComplete="one-time-code"
          />
        </label>
        <label className="cp-field">
          New password
          <input
            type="password"
            autoComplete="new-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            minLength={8}
            maxLength={128}
          />
        </label>
        <label className="cp-field">
          Confirm password
          <input
            type="password"
            autoComplete="new-password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            required
            minLength={8}
            maxLength={128}
          />
        </label>
        <Button type="submit" disabled={busy}>
          {busy ? 'Updating…' : 'Update password'}
        </Button>
        <p className="cp-muted">
          <Link to="/app/login">Back to sign in</Link>
        </p>
      </form>
    </div>
  )
}
